export const Youtube = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0s24 10.7452 24 24-10.7452 24-24 24S0 37.2548 0 24Z"
      fill="red"
    />
    <path
      d="M36.265 18.0732c-.2944-1.131-1.1619-2.0216-2.2634-2.3239C32.0054 15.2 24 15.2 24 15.2s-8.0054 0-10.0017.5493c-1.1016.3023-1.9691 1.1929-2.2635 2.3239C11.2 20.1231 11.2 24.4 11.2 24.4s0 4.2768.5348 6.3268c.2944 1.131 1.1619 2.0216 2.2635 2.324C15.9946 33.6 24 33.6 24 33.6s8.0054 0 10.0016-.5492c1.1015-.3024 1.969-1.193 2.2634-2.324.535-2.05.535-6.3268.535-6.3268s0-4.2769-.535-6.3268Z"
      fill="#fff"
    />
    <path d="M21.6 28.8v-8l6.4 4.0001L21.6 28.8Z" fill="red" />
  </svg>
)

export const Twitter = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0s24 10.7452 24 24-10.7452 24-24 24S0 37.2548 0 24Z"
      fill="#55ACEE"
    />
    <path
      d="m23.2812 19.5075.0504.8305-.8394-.1017c-3.0553-.3898-5.7245-1.7118-7.9909-3.932l-1.1079-1.1016-.2854.8135c-.6044 1.8135-.2183 3.7286 1.0408 5.0166.6715.7119.5204.8136-.6379.3899-.4029-.1356-.7555-.2373-.789-.1865-.1175.1187.2854 1.6609.6043 2.2711.4365.8474 1.3262 1.6778 2.2999 2.1693l.8226.3898-.9737.017c-.9401 0-.9737.0169-.8729.3728.3357 1.1016 1.6619 2.2711 3.1392 2.7795l1.0409.3559-.9066.5423c-1.343.7797-2.921 1.2203-4.499 1.2542-.7555.017-1.3766.0847-1.3766.1356 0 .1695 2.0481 1.1186 3.24 1.4914 3.5757 1.1016 7.823.6271 11.0126-1.2541 2.2663-1.3389 4.5326-3.9998 5.5902-6.5759.5708-1.3728 1.1416-3.8811 1.1416-5.0844 0-.7796.0503-.8813.9904-1.8134.554-.5424 1.0744-1.1356 1.1752-1.305.1678-.322.1511-.322-.7051-.0339-1.4269.5084-1.6284.4406-.9233-.322.5204-.5424 1.1415-1.5254 1.1415-1.8135 0-.0508-.2518.0339-.5372.1864-.3021.1695-.9736.4237-1.4773.5763l-.9065.2881-.8226-.5593c-.4532-.3051-1.0912-.644-1.4269-.7457-.8562-.2373-2.1656-.2034-2.9378.0678-2.0985.7627-3.4247 2.7286-3.2736 4.881Z"
      fill="#fff"
    />
  </svg>
)

export const Figma = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0s24 10.7452 24 24-10.7452 24-24 24S0 37.2548 0 24Z"
      fill="#333"
    />
    <path
      d="M19.2 38.3999c2.651 0 4.8-2.149 4.8-4.8v-4.8h-4.8c-2.651 0-4.8 2.1491-4.8 4.8 0 2.651 2.149 4.8 4.8 4.8Z"
      fill="#0ACF83"
    />
    <path
      d="M14.4 24c0-2.651 2.149-4.8 4.8-4.8H24v9.6h-4.8c-2.651 0-4.8-2.1491-4.8-4.8Z"
      fill="#A259FF"
    />
    <path
      d="M14.4 14.4c0-2.651 2.149-4.80002 4.8-4.80002H24V19.2h-4.8c-2.651 0-4.8-2.1491-4.8-4.8Z"
      fill="#F24E1E"
    />
    <path
      d="M24 9.59998h4.8c2.651 0 4.8 2.14902 4.8 4.80002 0 2.6509-2.149 4.8-4.8 4.8H24V9.59998Z"
      fill="#FF7262"
    />
    <path
      d="M33.6 24c0 2.6509-2.149 4.8-4.8 4.8S24 26.6509 24 24c0-2.651 2.149-4.8 4.8-4.8s4.8 2.149 4.8 4.8Z"
      fill="#1ABCFE"
    />
  </svg>
)

export const GoogleDrive = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m3.62887 39.756 2.11682 3.6563c.43987.7698 1.07218 1.3746 1.81445 1.8145l7.56016-13.0859H0c0 .8522.219921 1.7044.659784 2.4742L3.62887 39.756Z"
      fill="#0066DA"
    />
    <path
      d="M24 16.7457 16.4399 3.65979c-.7423.43986-1.3746 1.04467-1.8145 1.81443L.659784 29.6667C.228011 30.4198.00057488 31.2727 0 32.1409h15.1203L24 16.7457Z"
      fill="#00AC47"
    />
    <path
      d="M40.4399 45.2268c.7422-.4399 1.3745-1.0447 1.8144-1.8145l.8797-1.512 4.2062-7.2852c.4399-.7698.6598-1.622.6598-2.4742H32.8786l3.2176 6.323 4.3437 6.7629Z"
      fill="#EA4335"
    />
    <path
      d="m24 16.7457 7.5601-13.08591C30.8179 3.21993 29.9656 3 29.0859 3H18.9141c-.8797 0-1.732.24742-2.4742.65979L24 16.7457Z"
      fill="#00832D"
    />
    <path
      d="M32.8797 32.1409H15.1203L7.56014 45.2268c.74226.4398 1.5945.6598 2.47426.6598h27.9312c.8797 0 1.732-.2475 2.4742-.6598l-7.5601-13.0859Z"
      fill="#2684FC"
    />
    <path
      d="M40.3574 17.5704 33.3746 5.47422c-.4399-.76976-1.0722-1.37457-1.8145-1.81443L24 16.7457l8.8797 15.3952h15.0928c0-.8523-.2199-1.7045-.6598-2.4742l-6.9553-12.0963Z"
      fill="#FFBA00"
    />
  </svg>
)

export const Giphy = () => (
  <svg
    height="48"
    width="48"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="4 2 16.32 20"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M6.331 4.286H17.99v15.428H6.33z" fill="#000" />
      <g fillRule="nonzero">
        <path d="M4 3.714h2.331v16.572H4z" fill="#04ff8e" />
        <path d="M17.989 8.286h2.331v12h-2.331z" fill="#8e2eff" />
        <path d="M4 19.714h16.32V22H4z" fill="#00c5ff" />
        <path d="M4 2h9.326v2.286H4z" fill="#fff152" />
        <path
          d="M17.989 6.571V4.286h-2.332V2h-2.331v6.857h6.994V6.571"
          fill="#ff5b5b"
        />
        <path d="M17.989 11.143V8.857h2.331" fill="#551c99" />
      </g>
      <path d="M13.326 2v2.286h-2.332" fill="#999131" />
    </g>
  </svg>
)
